import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import strFunc from '@/lib/lyg/string';

function SearchArea(props: any) {
  let myProps = {
    list: (inData: any) => { },
    listOpt: {},
    setListOpt: (inData: any) => { },
    ...props
  };
  let listOpt = myProps.listOpt;
  const [sort1_arr, set_sort1_arr] = useState([]);
  const [sort2_arr, set_sort2_arr] = useState([]);
  let select_stu_grade_arr = XcolumnFunc.getSortByTableKey({ 'table': 'user', 'key': 'a_stu_grade' });

  const handleSearch = (e: any) => {
    let target = e.target;
    let name = target.name;
    let value = target.value;

    let change_list_opt: any = {};
    change_list_opt[name] = value;

    if (name == "s_sort1") {
      let tmp_select_sort1_seq = "";
      for (let s_i = 0; s_i < sort1_arr.length; s_i++) {
        let tmp_sort_row: any = sort1_arr[s_i];
        if (tmp_sort_row.a_title == value) {
          tmp_select_sort1_seq = tmp_sort_row.a_seq;
        }
      }
      if (tmp_select_sort1_seq) {
        get_sort_arr_by_ajax({
          s_type: "sort2",
          s_par_seq: tmp_select_sort1_seq,
        });
      } else {
        set_sort2_arr([]);
      }
      change_list_opt.s_sort2 = "";
    }

    if (target.tagName.toLowerCase() === "select"
      || target.type === "checkbox" || target.type === "radio") {
      myProps.list({
        ...change_list_opt,
        now_page: 1
      });
    } else {
      myProps.setListOpt({
        ...listOpt,
        ...change_list_opt
      });
    }
  };

  const on_keyup_enter = (e: any) => {
    if (e.key === "Enter") {
      myProps.list({ now_page: 1 });
    }
  };

  useEffect(() => {
    get_sort_arr_by_ajax({
      s_type: "sort1",
      s_par_seq: "",
    });
  }, []);

  const get_sort_arr_by_ajax = (inData: any) => {
    let tmp_listOpt: any = {
      s_type: "sort1",
      s_par_seq: "",
      ...inData
    };

    let form_json_data: any = {
      ...tmp_listOpt,
      s_mcomp_seq: "1",
      s_par_id: "word_inside_sort",
      order_id:"a_order_num",
      is_paging: "",
    };

    if (form_json_data.s_type != "sort1") {
      if (strFunc.is_empty(form_json_data.s_par_seq)) {
        if (form_json_data.s_type == "sort2") {
          set_sort2_arr([]);
        }
        return false;
      }
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside_sort/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (form_json_data.s_type == "sort1") {
            set_sort1_arr(response.data["data"]["info_arr"]);
          } else if (form_json_data.s_type == "sort2") {
            set_sort2_arr(response.data["data"]["info_arr"]);
          }
        } else {

        }
      });
  };

  return (
    <div className="my_flex_center">
      <select className="search-input"
        value={myProps.listOpt.s_word_type} name="s_word_type" onChange={handleSearch} >
        <option value="">유형</option>
        <option value="word">단어</option>
        <option value="stc">문장</option>
      </select>
      <select className='search-input'
        value={listOpt.s_sort1} name="s_sort1" onChange={handleSearch}
      >
        <option value="">대분류</option>
        {sort1_arr.map((item: any, idx: number) => {
          return (
            <option key={idx} value={item.a_title}>{item.a_title}</option>
          )
        })}
      </select>
      <select className='search-input'
        value={listOpt.s_sort2} name="s_sort2" onChange={handleSearch}
      >
        <option value="">중분류</option>
        {sort2_arr.map((item: any, idx: number) => {
          return (
            <option key={idx} value={item.a_title}>{item.a_title}</option>
          )
        })}
      </select>
      <select className='search-input'
        value={listOpt.s_stu_grade} name="s_stu_grade" onChange={handleSearch}
      >
        <option value="">학년</option>
        <option value="baby">미취학</option>
        <option value="elementary">초등</option>
        <option value="middle">중등</option>
        <option value="high">고등</option>
        {select_stu_grade_arr.map((item: any, idx: number) => {
          return (
            <option key={idx} value={item.value}>{item.text}</option>
          )
        })}
      </select>

      <input type="text" className="search-input"
        value={myProps.listOpt.s_book_title_like} name="s_book_title_like"
        placeholder="교재"
        onChange={handleSearch}
        onKeyUp={on_keyup_enter}
        style={{ width: "80px" }}
        autoComplete="off" />

      <input type="text" className="search-input"
        value={myProps.listOpt.s_book_section_like} name="s_book_section_like"
        placeholder="단원"
        onChange={handleSearch}
        onKeyUp={on_keyup_enter}
        style={{ width: "80px" }}
        autoComplete="off" />

      <input type="text" className="search-input"
        value={myProps.listOpt.s_book_unit} name="s_book_unit"
        placeholder="유닛"
        onChange={handleSearch}
        onKeyUp={on_keyup_enter}
        style={{ width: "70px" }}
        autoComplete="off" />

      <input type="text" className="search-input"
        value={myProps.listOpt.s_year} name="s_year"
        placeholder="년도"
        onChange={handleSearch}
        onKeyUp={on_keyup_enter}
        style={{ width: "70px" }}
        autoComplete="off" />

      <input type="text" className="search-input"
        value={myProps.listOpt.s_round_num} name="s_round_num"
        placeholder="회차"
        onChange={handleSearch}
        onKeyUp={on_keyup_enter}
        style={{ width: "70px" }}
        autoComplete="off" />

      <input type="text" className="search-input"
        value={myProps.listOpt.s_title_like} name="s_title_like"
        placeholder="제목"
        onChange={handleSearch}
        onKeyUp={on_keyup_enter}
        style={{ width: "100px" }}
        autoComplete="off" />
      <button className="btn btn-dark" onClick={() => { myProps.list({}); }}>검색</button>
    </div>
  );
};
export default SearchArea;